<template>
  <div class="img-wrap">
    <el-image
        :src="imageSrc"
        class="cover"
        :style="{ width: width, height: height }"
        @click="checkMedia(src, 'img')"
    >
      <div
          slot="placeholder"
          class="image-slot"
          :style="{ width: width, height: height, lineHeight: height }"
      >
        <i class="el-icon-loading"></i>加载中
      </div>
    </el-image>
    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup"></media-popup>
  </div>
</template>
<script>
import MediaPopup from "@/components/media-popup";
import imageURLDecrypt from "@/components/imageURLDecrypt";

export default {
  data() {
    return {
      imageSrc: "",
    };
  },
  components: {
    MediaPopup,
  },
  props: {
    width: {
      type: String,
      required: false,
      defalt:"100%"
    },
    height: {
      type: String,
      required: true,
      defalt:"100%"
    },
    src: {
      type: String,
      required: true,
    },
    hasShowMediaPopup: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // 查看媒体
    checkMedia(url, type) {
      this.$refs.mediaPopup.open(url, type);
    },
    async LoadImageURL() {
      if (this.$props.src.indexOf("/src/") != -1) {
        return this.$props.src;
      }
      if (this.$props.src.indexOf("/assets/") != -1) {

        return this.$props.src;
      }

      const src = await imageURLDecrypt(this.$props.src);
      return src;
    },
  },
  async mounted() {
    this.imageSrc = await this.LoadImageURL();
  },
};
</script>

<style lang="scss">
.img-wrap {
  display: flex;
  justify-content: center;
  cursor: pointer;

  .image-slot {
    background: #f5f7fa;
    font-size: 12px;
    color: #c0c4cc;
  }

  .el-image__error {
    font-size: 12px;
  }
}
</style>
